<script setup lang="ts">
import { useEventClock } from '@desktop/views/Relation/Sports/composables'

import EventClockInput from './EventClockInput.vue'

// composables
const {
  updateTimerMinute,
  currentPeriodLengthMinutes,
  isValidEventClockTime,
  eventTime,
} = useEventClock()

// methods
function onUpdate(
  newValue: string,
  oldValue: string,
  callback: (currentValue: string) => void,
): void {
  const value = parseInt(newValue)

  if (
    value >= 0 &&
    value <= 255 &&
    isValidEventClockTime({
      minute: value,
      second: eventTime.value.second,
      periodLengthMinutes: currentPeriodLengthMinutes.value,
    })
  ) {
    updateTimerMinute(value)
    callback(newValue)
  } else {
    // if value is invalid, revert to old value
    callback(oldValue)
  }
}
</script>

<template>
  <EventClockInput
    type="minute"
    :maxlength="3"
    data-testid="event-clock-minute-input"
    @update="onUpdate"
  />
</template>
